import axiosInstance from "./AxiosInstance";
import defaultAvatar from "../../src/assets/images/placeholder.jpg";
import { formatName } from "../utils/formatName"

export function getReceptionists(doctorId, isMulti = "NO") {
  return axiosInstance.post("/admin/PatientQueueList", {
    doctor_id: doctorId,
    is_multi: isMulti,
  });
}

export function createReceptionist(qrcodescanData, doctorId) {
  return axiosInstance.post("/admin/addPatientQueue", {
    qrcodescanData,
    doctor_id: doctorId,
  });
}

export function upcomingAppointment(date) {
  return axiosInstance.post("/admin/upcomingAppointment", {
    search_date: date,
  });
}

export function markPatientAsCurrent(queue_id) {
  return axiosInstance.post("/admin/addmarkCurrent", { queue_id });
}

export function addVitals(formData) {
  return axiosInstance.post("/admin/addVitals", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function collectPayment(paymentData) {
  return axiosInstance.post("/admin/collectPayment", paymentData);
}

export function SendFormLink(patient_id) {
  return axiosInstance.post("/patient/sendFormLink", patient_id);
}

// Updated pauseDoctorQueue function to send is_pause parameter
export function pauseDoctorQueue(doctor_id, is_pause = "Yes") {
  return axiosInstance.post("/patient/DoctorqueuePause", {
    doctor_id: doctor_id,
    is_pause: is_pause,
  });
}

// Mark patient as emergency
export function markPatientEmergency(queue_id) {
  return axiosInstance.post("/patient/queuePatientIsEmergency", {
    queue_id: queue_id,
  });
}

// Mark patient as complete
export function markPatientComplete(queue_id) {
  return axiosInstance.post("/patient/addMarkComplete", {
    queue_id: queue_id,
  });
}
export function getEmergencyPatients() {
  return axiosInstance.post("/patient/emergencyMarkPatients");
}
// export function bookedAppointments(date,doctor_id = null) {
//   console.log("📡 SERVICE CALL", { date });

//   return axiosInstance.post("/receptionist/appointments", {
//     date,
//     doctor_id, 
//     is_payment: "Yes",
//     is_confirmed: "Yes",

 
//     // admin_id: 22, // or from auth later
//   });
// }
export function bookedAppointments(date, doctor_id = null, isPayment = "Yes") {
  console.log("📡 SERVICE CALL", { date, doctor_id, isPayment });

  return axiosInstance.post("/receptionist/appointments", {
    date,
    doctor_id,
    is_payment: isPayment, // Now dynamic: "Yes" or "No"
    is_confirmed: "Yes",
    // admin_id: 22, // or from auth later
  });
}



// export function rescheduleAppointments(data) {
//   return axiosInstance.post(
//     "/receptionist/appointments/reschedule",
//     data
//   );
// }
export function rescheduleAppointments(data) {
  return fetch(
    axiosInstance.defaults.baseURL +
      "/receptionist/appointments/reschedule",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          axiosInstance.defaults.headers?.Authorization || "",
      },
      body: JSON.stringify({
        appointment_id: data.appointment_id,
        date: data.date,
        mode: data.mode,
        branch: data.branch,
        // time_slot: data.time_slot,
      }),
    }
  ).then((res) => res.json());
}
export const addBackToQueueService = (queue_id) => {
  return axiosInstance.post("/patient/addBackToQueue", {
    queue_id,
  });
};


export function uploadPatientPhoto(patient_id, patient_photo) {
  const formData = new FormData();
  formData.append("patient_id", patient_id);
  formData.append("patient_photo", patient_photo); // file object (jpeg)

  return axiosInstance.post(
    "patient/updatepatientPhoto",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}
export function formatReceptionists(data, isGrouped = false) {
  if (!data || !Array.isArray(data)) return [];

  // Handle grouped response (when is_multi = "YES")
  if (isGrouped && data.length > 0 && data[0].patients) {
    const allPatients = [];
    data.forEach((doctorGroup) => {
      if (doctorGroup.patients && Array.isArray(doctorGroup.patients)) {
        allPatients.push(...doctorGroup.patients);
      }
    });
    return formatPatientData(allPatients);
  }

  // Handle flat response (when is_multi = "NO")
  return formatPatientData(data);
}




function formatPatientData(data) {
  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString || dateString === "0000-00-00") return "-";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    } catch (e) {
      return dateString;
    }
  };

  const formattedData = data.map((item) => {
    const hasPatientDetails = item.patient_id !== null;
    return {
      queue_id: item.queue_id,
      patient_id: item.patient_id,
      appointment_id: item.appointment_id,
      lead_id: item.lead_id,
      doctor_id: item.doctor_id,
      doctor_name: item.doctor_name,
      date: formatDate(item.date),
      raw_date: item.date,  
      // name: hasPatientDetails
      //   ? `${item.first_name || ""} ${item.middile_name || ""} ${
      //       item.last_name || ""
      //     }`.trim()
      //   : "N/A",
      name: hasPatientDetails
      ? formatName(
          `${item.first_name || ""} ${item.middile_name || ""} ${item.last_name || ""}`.trim()
        )
      : "N/A",
    
    

      avatar:
        hasPatientDetails && item.patient_photo
          ? item.patient_photo
          : defaultAvatar,
      time_slot: item.time_slot || "-",
      reason: hasPatientDetails
        ? item.occupation || "General Checkup"
        : "New Registration",
      token_no: String(item.token_no).padStart(2, "0"),
      first_name: item.first_name,
      last_name: item.last_name,
      patient_photo: item.patient_photo,
      occupation: item.occupation,
      created_at: item.created_at,
      status: item.patient_marked || "",
      contact: hasPatientDetails
        ? item.whatsapp_contact_no || item.additional_contact_no
        : "",
        showCollectButton:
        item.is_payment?.toLowerCase() === "no" ? true : false,
      weight: item.weight,
      height: item.height,
      gender: item.gender,
      whatsapp_contact_no: item.whatsapp_contact_no,
      showCollectButton: item.is_payment === "No",         
      showReceiptIcon: item.is_payment === "Yes",         
      receipt_download_link: item.receipt_download_link,    
      payment_id: item.patient_id,   
      age: calculateAge(item.date_of_birth),
      systolic_bp: item.systolic_bp,
      diastolic_bp: item.diastolic_bp,
      bmi: item.bmi,
      pluse_rate: item.pluse_rate,
      temperature: item.temperature,
      Oxygen_Saturation: item.Oxygen_Saturation,
      blood_glucose_level: item.blood_glucose_level,
      Allergies: item.Allergies,
      Reports_Upload: item.Reports_Upload,
      questionnaire_filled: item.queueDetails?.questionnaire_filled || item.questionnaire_filled || "No",
      is_emergency: item.is_emergency,
      is_pause: item.is_pause,
      is_firsttime_visitor: item.is_firsttime_visitor,
      // remainder defined static
      attend_status: item.attend || item.attended_status || "Not Attended",
      showReminder: (item.attend || item.attended_status) === "Attended" ? false : true,
      
      mode: item.mode
        ? item.mode.charAt(0) + item.mode.slice(1).toLowerCase()
        : "",
        disease: item.diseases || item.opd_diseases || "N/A", 
    };
  });

  function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }
    return age;
  }

  return formattedData;
}

export function removePatient(queue_id) {
  return axiosInstance.post("/admin/cancelAppointment", { queue_id });
}

export function getPatientQueue() {
  return axiosInstance.post("/admin/PatientQueueList").then((response) => {
    if (
      !response.data ||
      !response.data.data ||
      !Array.isArray(response.data.data)
    ) {
      console.error("Unexpected API response structure:", response.data);
      return [];
    }
    const patientsWithPrescriptions = response.data.data.map((patient) => ({
      ...patient,
      prescriptions: patient.prescriptions || [],
    }));
    return patientsWithPrescriptions;
  });
}

export function getAvailableSlots(
  startDate,
  endDate,
  leadId,
  adminId = 7,
  doctorId = 1,
  patientId
) {
  return axiosInstance.post("/lead/availableTimeSlot", {
    admin_id: adminId,
    lead_id: leadId,
    doctor_id: doctorId,
    start_date: startDate,
    end_date: endDate,
    patient_id: patientId,
  });
}

export function rescheduleAppointment(data) {
  return axiosInstance.post("/servicecaller/appointmentReschedule", data);
}

export function rescheduleQueueAppointment(data) {
  return axiosInstance.post("/admin/reschedule", data);
}
// mark as next
export function markPatientNext(queue_id) {
  return axiosInstance.post("/patient/addMarkNext", {
    queue_id: queue_id,
  });
}

export function sendReminder(appointment_id) {
  return axiosInstance.post("/lead/sendReminder", {
    appointment_id: appointment_id,
  });
}
export function addSearchPatientQueue(  appointment_id = 0,patient_id, doctor_id, time_slot, date,branch_id) {
  return axiosInstance.post("/patient/addSearchPatientQueue", {
    appointment_id,
    patient_id,
    doctor_id,
    time_slot,
    date,
    branch_id,

  });
}
// export function formatBookedAppointments(data) {
//   if (!Array.isArray(data)) return [];

//   return data
//     .filter(item => item.appointment_id !== null) // ⭐ FILTER EMPTY RECORDS
//     .map((item) => ({
//       id: item.appointment_id,
//       avatar: defaultAvatar,
//       name: item.patient_name || "N/A",
//       diseases: item.diseases || "General",
//       doctor: item.doctor_name || "N/A",
//       date: item.date || "-",
//       timeSlot: item.time_slot || "-",
//       mode: item.mode || "-",
//       status: item.appointment_status || "Waiting",
//       appointmentType: item.appointment_type || "General",
//       isPayment: item.is_payment || "No",
//       isConfirmed: item.is_confirmed || "No",
//       lead_id: item.lead_id,
//       doctor_id: item.doctor_id,
//       phone: item.phone_no || "-",
//       email: item.email || "-",
//       branch: item.branch_name || "-",
//     }));
// }
// export function formatBookedAppointments(data) {
//   if (!Array.isArray(data)) return [];

//   return data
//     .filter(item => item.appointment_id !== null)
//     .map((item) => ({
//       id: item.appointment_id,

//       // ⭐ IMPORTANT
//       queue_id: item.queueDetails?.queue_id || null,

//       avatar: defaultAvatar,
//       name: item.patient_name || "N/A",
//       diseases: item.diseases || "General",
//       doctor: item.doctor_name || "N/A",
//       date: item.date || "-",
//       timeSlot: item.time_slot || "-",
//       mode: item.mode || "-",
//       status: item.appointment_status || "Waiting",
//       appointmentType: item.appointment_type || "General",
//       isPayment: item.is_payment || "No",
//       isConfirmed: item.is_confirmed || "No",

//       lead_id: item.lead_id,
//       doctor_id: item.doctor_id,
//       patient_id: item.patient_id,   // ⭐ also important for enqueue

//       phone: item.phone_no || "-",
//       email: item.email || "-",
//       branch: item.branch_name || "-",

//       // ⭐ optional – keep full queue object if needed later
//       queueDetails: item.queueDetails || null,
//     }));
// }
// export function formatBookedAppointments(data) {
//   if (!Array.isArray(data)) return [];

//   return data
//     .filter(item => item.appointment_id !== null)
//     .filter(item => {
//       const hasQueue =
//         item.queueDetails &&
//         !Array.isArray(item.queueDetails) &&
//         Object.keys(item.queueDetails).length > 0 &&
//         item.queueDetails.patient_marked !== "Cancel";

//       const notScannedYet = item.is_presented === "No";

//       return hasQueue || notScannedYet;
//     })
//     .map(item => {
//       const queue =
//         item.queueDetails && !Array.isArray(item.queueDetails)
//           ? item.queueDetails
//           : {};

//       const isNewPatient =
//         item.is_presented === "No" &&
//         (!item.queueDetails ||
//           Array.isArray(item.queueDetails) ||
//           Object.keys(queue).length === 0);

//       const mark = queue.patient_marked || "Waiting";

//       const dob = isNewPatient ? item.date_of_birth : queue.date_of_birth;

//       return {
//         id: item.appointment_id,

//         queue_id: queue.queue_id || null,
//         token_no: isNewPatient ? item.token_no || "0" : queue.token_no || "0",
//         patient_marked: mark,

//         is_payment: isNewPatient ? item.is_payment || "No" : queue.is_payment || "No",
//         is_emergency: queue.is_emergency || "No",
//         is_pause: queue.is_pause || "No",

//         questionnaire_filled: isNewPatient
//           ? "No"
//           : queue.questionnaire_filled || "No",

//         systolic_bp: isNewPatient ? null : queue.systolic_bp,
//         diastolic_bp: isNewPatient ? null : queue.diastolic_bp,
//         bmi: isNewPatient ? null : queue.bmi,
//         pluse_rate: isNewPatient ? null : queue.pluse_rate,
//         temperature: isNewPatient ? null : queue.temperature,
//         Oxygen_Saturation: isNewPatient ? null : queue.Oxygen_Saturation,
//         blood_glucose_level: isNewPatient ? null : queue.blood_glucose_level,
//         Allergies: isNewPatient ? null : queue.Allergies,
//         Reports_Upload: isNewPatient ? null : queue.Reports_Upload,
//         height: isNewPatient ? null : queue.height,
//         weight: isNewPatient ? null : queue.weight,
 
//         gender: isNewPatient ? item.gender || "N/A" : queue.gender || "N/A",
//         occupation: isNewPatient ? item.occupation || "" : queue.occupation || "",

//         whatsapp_contact_no: isNewPatient
//           ? item.phone_no
//           : queue.whatsapp_contact_no || item.phone_no,

//         date_of_birth: dob || null,

//         doctor: isNewPatient
//           ? item.doctor_name || "N/A"
//           : queue.doctor_name || item.doctor_name || "N/A",

//           marital_status:
//           (isNewPatient ? item.is_married : queue.is_married || item.is_married) === "Yes"
//             ? "Married"
//             : "Not Married",

//         patient_photo: isNewPatient
//           ? item.patient_photo || defaultAvatar
//           : queue.patient_photo || defaultAvatar,

//         attend_status:
//           item.appointment_visited === "Yes" ? "Attended" : "Not Attended",

//         is_presented: item.is_presented || "No",

//         showReminder: item.appointment_visited !== "Yes",

//         avatar: defaultAvatar,
//         name: isNewPatient
//         ? item.patient_name || item.patient_full_name || "N/A"
//         : `${queue.first_name || ""} ${queue.last_name || ""}`.trim() ||
//           item.patient_name ||
//           item.patient_full_name ||
//           "N/A",
//         diseases: item.diseases || "General",
//         date: item.date || "-",
//         timeSlot: item.time_slot || "-",
//         mode: item.mode || "-",
//         status: mark,
//         partner_added: item.partner_added || "No",
// partner_id: item.partner_id || "0",
// partner_name: item.partner_name || " ",
// partner_phone: item.partner_phone || "",
//         patient_id: item.patient_id,
//         doctor_id: item.doctor_id,
//         phone: item.phone_no || "-",
//         email: item.email || "-",
//         branch: item.branch_name || "-",

//         showCollectButton: isNewPatient
//           ? item.is_payment === "No"
//           : queue.is_payment === "No",

//         showReceiptIcon: isNewPatient
//           ? item.is_payment === "Yes"
//           : queue.is_payment === "Yes",

//         receipt_download_link: isNewPatient
//           ? item.receipt_download_link || null
//           : queue.receipt_download_link || null,

//         payment_id: isNewPatient
//           ? item.patient_id
//           : queue.patient_id || item.patient_id,

//         is_new_patient: isNewPatient,

//         appointment_type: item.appointment_type,
//         lead_id: item.lead_id,
//         rescheduled_cnt: item.rescheduled_cnt || "0",
//         telecaller_note: item.telecaller_note,
//         cancellation_note: item.cancellation_note,

//         age: dob
//           ? new Date().getFullYear() - new Date(dob).getFullYear()
//           : null,
//       };
//     })
//     .filter(item => item.patient_marked !== "Cancel")
//     .sort((a, b) => {
//       const order = { Current: 1, Next: 2, Waiting: 3 };
//       return (order[a.status] || 99) - (order[b.status] || 99);
//     });
// }
// export function formatBookedAppointments(data) {
//   if (!Array.isArray(data)) return [];

//   return data
//     .filter(item => item.appointment_id !== null)
//     .filter(item => {
//       const hasQueue =
//         item.queueDetails &&
//         !Array.isArray(item.queueDetails) &&
//         Object.keys(item.queueDetails).length > 0 &&
//         item.queueDetails.patient_marked !== "Cancel";

//       const notScannedYet = item.is_presented === "No";

//       return hasQueue || notScannedYet;
//     })
//     .map(item => {
//       const queue =
//         item.queueDetails && !Array.isArray(item.queueDetails)
//           ? item.queueDetails
//           : {};

//       const isNewPatient =
//         item.is_presented === "No" &&
//         (!item.queueDetails ||
//           Array.isArray(item.queueDetails) ||
//           Object.keys(queue).length === 0);

//       const mark = queue.patient_marked || "Waiting";
//       const dob = isNewPatient ? item.date_of_birth : queue.date_of_birth;

//       // ✅ CRITICAL: Get patient_id from queueDetails since top-level is null
//       const patient_id = queue.patient_id || item.patient_id || null;

//       // Log for debugging
//       console.log("Formatting appointment:", {
//         appointment_id: item.appointment_id,
//         patient_id: patient_id,
//         queue_patient_id: queue.patient_id,
//         item_patient_id: item.patient_id,
//         name: queue.first_name ? `${queue.first_name} ${queue.last_name || ''}`.trim() : item.patient_name,
//         isNewPatient
//       });

//       return {
//         id: item.appointment_id,
//         queue_id: queue.queue_id || null,
//         token_no: isNewPatient ? item.token_no || "0" : queue.token_no || "0",
//         patient_marked: mark,

//         is_payment: isNewPatient ? item.is_payment || "No" : queue.is_payment || "No",
//         is_emergency: queue.is_emergency || "No",
//         is_pause: queue.is_pause || "No",

//         questionnaire_filled: isNewPatient
//           ? "No"
//           : queue.questionnaire_filled || "No",

//         systolic_bp: isNewPatient ? null : queue.systolic_bp,
//         diastolic_bp: isNewPatient ? null : queue.diastolic_bp,
//         bmi: isNewPatient ? null : queue.bmi,
//         pluse_rate: isNewPatient ? null : queue.pluse_rate,
//         temperature: isNewPatient ? null : queue.temperature,
//         Oxygen_Saturation: isNewPatient ? null : queue.Oxygen_Saturation,
//         blood_glucose_level: isNewPatient ? null : queue.blood_glucose_level,
//         Allergies: isNewPatient ? null : queue.Allergies,
//         Reports_Upload: isNewPatient ? null : queue.Reports_Upload,
//         height: isNewPatient ? null : queue.height,
//         weight: isNewPatient ? null : queue.weight,

//         // Patient details - prefer queue data
//         gender: !isNewPatient && queue.gender ? queue.gender : item.gender || "N/A",
//         occupation: !isNewPatient && queue.occupation ? queue.occupation : item.occupation || "",
        
//         whatsapp_contact_no: !isNewPatient && queue.whatsapp_contact_no 
//           ? queue.whatsapp_contact_no 
//           : item.phone_no || "",

//         date_of_birth: dob || null,

//         doctor: !isNewPatient && queue.doctor_name 
//           ? queue.doctor_name 
//           : item.doctor_name || "N/A",

//         marital_status: !isNewPatient && queue.is_married 
//           ? (queue.is_married === "Yes" ? "Married" : "Not Married")
//           : (item.is_married === "Yes" ? "Married" : "Not Married"),

//         // ✅ Patient photo from queue
//         patient_photo: !isNewPatient && queue.patient_photo 
//           ? queue.patient_photo 
//           : item.patient_photo || defaultAvatar,

//         attend_status: item.appointment_visited === "Yes" ? "Attended" : "Not Attended",
//         is_presented: item.is_presented || "No",
//         showReminder: item.appointment_visited !== "Yes",
//         avatar: defaultAvatar,

//         // ✅ Patient name from queue
//         name: !isNewPatient && queue.first_name
//           ? `${queue.first_name || ''} ${queue.middile_name || ''} ${queue.last_name || ''}`.trim()
//           : item.patient_name || item.patient_full_name || "N/A",

//         diseases: item.diseases || "General",
//         date: item.date || "-",
//         timeSlot: item.time_slot || "-",
//         mode: item.mode || "-",
//         status: mark,

//         partner_added: queue.partner_added || item.partner_added || "No",
//         partner_id: queue.partner_id || item.partner_id || "0",
//         partner_name: queue.partner_name || item.partner_name || "",
//         partner_phone: queue.partner_phone || item.partner_phone || "",

//         // ✅ CRITICAL: Set patient_id from queue (used for photo upload)
//         patient_id: patient_id,

//         doctor_id: item.doctor_id,
//         phone: !isNewPatient && queue.whatsapp_contact_no 
//           ? queue.whatsapp_contact_no 
//           : item.phone_no || "-",
//         email: queue.patient_email || item.email || "-",
//         branch: item.branch_name || "-",

//         showCollectButton: !isNewPatient 
//           ? queue.is_payment === "No"
//           : item.is_payment === "No",

//         showReceiptIcon: !isNewPatient
//           ? queue.is_payment === "Yes"
//           : item.is_payment === "Yes",

//         receipt_download_link: !isNewPatient
//           ? queue.receipt_download_link || null
//           : item.receipt_download_link || null,

//         // ✅ Fix payment_id to use the same patient_id logic
//         payment_id: patient_id,

//         is_new_patient: isNewPatient,

//         appointment_type: item.appointment_type,
//         lead_id: item.lead_id || queue.lead_id,
//         rescheduled_cnt: item.rescheduled_cnt || "0",
//         telecaller_note: item.telecaller_note,
//         cancellation_note: item.cancellation_note,

//         age: dob
//           ? new Date().getFullYear() - new Date(dob).getFullYear()
//           : null,
//       };
//     })
//     .filter(item => item.patient_marked !== "Cancel")
//     .sort((a, b) => {
//       const order = { Current: 1, Next: 2, Waiting: 3 };
//       return (order[a.status] || 99) - (order[b.status] || 99);
//     });
// }
// export function formatBookedAppointments(data) {
//   if (!Array.isArray(data)) return [];

//   return data
//     .filter(item => item.appointment_id !== null)
//     .map(item => {
//       const queue =
//         item.queueDetails && !Array.isArray(item.queueDetails)
//           ? item.queueDetails
//           : {};

//       const partner =
//         item.partnerDetails && !Array.isArray(item.partnerDetails)
//           ? item.partnerDetails
//           : {};

//       const isNewPatient =
//         item.is_presented === "No" &&
//         (!item.queueDetails ||
//           Array.isArray(item.queueDetails) ||
//           Object.keys(queue).length === 0);

//       // Get the patient_marked status
//       const mark = queue.patient_marked || "Waiting";
//       let receiptLink = null;
//       if (!isNewPatient) {
//         // For existing patients in queue, get from queue
//         receiptLink = queue.receipt_download_link || null;
//       } else {
//         // For new patients, get from main appointment object
//         receiptLink = item.receipt_download_link || null;
//       }
//       const dob = isNewPatient ? item.date_of_birth : queue.date_of_birth;
//       const patient_id = queue.patient_id || item.patient_id || null;
      
//       // CRITICAL: Extract queue_id from queueDetails
//       const queue_id = queue.queue_id || null;

//       // Return ALL items, don't filter them out
//       return {
//         id: item.appointment_id,

//         // CRITICAL: Set queue_id at top level
//         queue_id: queue_id,

//         token_no: isNewPatient
//           ? item.token_no || "0"
//           : queue.token_no || "0",

//         patient_marked: mark,

//         is_payment: isNewPatient
//           ? item.is_payment || "No"
//           : queue.is_payment || "No",

//         is_emergency: queue.is_emergency || "No",

//         is_pause: queue.is_pause || "No",

//         questionnaire_filled: !isNewPatient && queue.questionnaire_filled 
//           ? queue.questionnaire_filled 
//           : item.questionnaire_filled || "No",

//         systolic_bp: !isNewPatient ? queue.systolic_bp : null,
//         diastolic_bp: !isNewPatient ? queue.diastolic_bp : null,
//         bmi: !isNewPatient ? queue.bmi : null,
//         pluse_rate: !isNewPatient ? queue.pluse_rate : null,
//         temperature: !isNewPatient ? queue.temperature : null,
//         Oxygen_Saturation: !isNewPatient ? queue.Oxygen_Saturation : null,
//         blood_glucose_level: !isNewPatient ? queue.blood_glucose_level : null,
//         Allergies: !isNewPatient ? queue.Allergies : null,
//         Reports_Upload: !isNewPatient ? queue.Reports_Upload : null,
//         height: !isNewPatient ? queue.height : null,
//         weight: !isNewPatient ? queue.weight : null,

//         gender: !isNewPatient && queue.gender
//           ? queue.gender
//           : item.gender || "N/A",

//         occupation: !isNewPatient && queue.occupation
//           ? queue.occupation
//           : item.occupation || "",

//         whatsapp_contact_no: !isNewPatient && queue.whatsapp_contact_no
//           ? queue.whatsapp_contact_no
//           : item.phone_no || "",

//         date_of_birth: dob || null,

//         doctor: !isNewPatient && queue.doctor_name
//           ? queue.doctor_name
//           : item.doctor_name || "N/A",

//         marital_status: !isNewPatient && queue.is_married
//           ? queue.is_married === "Yes" ? "Married" : "Not Married"
//           : item.is_married === "Yes" ? "Married" : "Not Married",

//         patient_photo: !isNewPatient && queue.patient_photo
//           ? queue.patient_photo
//           : item.patient_photo || defaultAvatar,

//         attend_status: item.appointment_visited === "Yes" ? "Attended" : "Not Attended",
//         is_firsttime_visitor: item.is_firsttime_visitor || "No",
//         is_presented: item.is_presented || "No",

//         showReminder: item.appointment_visited !== "Yes",

//         avatar: defaultAvatar,

//         name: !isNewPatient && queue.first_name
//           ? `${queue.first_name || ""} ${queue.middile_name || ""} ${queue.last_name || ""}`.trim()
//           : item.patient_name || item.patient_full_name || "N/A",

//         diseases: item.diseases || "General",

//         date: item.date || "-",

//         timeSlot: item.time_slot || "-",

//         mode: item.mode || "-",

//         status: mark,

//         partner_id: partner?.patient_id || null,
//         partner_name: partner?.first_name
//           ? `${partner.first_name} ${partner.last_name || ""}`.trim()
//           : "",
//         partner_phone: partner?.whatsapp_contact_no || partner?.additional_contact_no || "",

//         patient_id: patient_id,
//         doctor_id: item.doctor_id,

//         phone: !isNewPatient && queue.whatsapp_contact_no
//           ? queue.whatsapp_contact_no
//           : item.phone_no || "-",

//         email: queue.patient_email || item.email || "-",
//         branch: item.branch_name || "-",

//         showCollectButton: !isNewPatient
//           ? queue.is_payment === "No"
//           : item.is_payment === "No",

//         showReceiptIcon: !isNewPatient
//           ? queue.is_payment === "Yes"
//           : item.is_payment === "Yes",

//           receipt_download_link: receiptLink,

//         payment_id: patient_id,
//         is_new_patient: isNewPatient,
//         appointment_type: item.appointment_type,
//         lead_id: item.lead_id || queue.lead_id,
//         rescheduled_cnt: item.rescheduled_cnt || "0",
//         telecaller_note: item.telecaller_note,
//         cancellation_note: item.cancellation_note,

//         age: dob ? new Date().getFullYear() - new Date(dob).getFullYear() : null
//       };
//     })
//     // Filter out "Cancel" AFTER we have all the data
//     .filter(item => item.patient_marked !== "Cancel")
//     .sort((a, b) => {
//       const order = { Current: 1, Next: 2, Waiting: 3 };
//       return (order[a.status] || 99) - (order[b.status] || 99);
//     });
// }
export function formatBookedAppointments(data) {
  if (!Array.isArray(data)) return [];

  return data
    .filter(item => item.appointment_id !== null)
    .map(item => {
      const queue =
        item.queueDetails && !Array.isArray(item.queueDetails)
          ? item.queueDetails
          : {};

      const partner =
        item.partnerDetails && !Array.isArray(item.partnerDetails)
          ? item.partnerDetails
          : {};

      const isNewPatient =
        item.is_presented === "No" &&
        (!item.queueDetails ||
          Array.isArray(item.queueDetails) ||
          Object.keys(queue).length === 0);

      // Get the patient_marked status
      const mark = queue.patient_marked || "Waiting";
      
      const dob = isNewPatient ? item.date_of_birth : queue.date_of_birth;
      const patient_id = queue.patient_id || item.patient_id || null;
      
      // CRITICAL: Extract queue_id from queueDetails
      const queue_id = queue.queue_id || null;

      // ✅ FIXED: Get receipt download link from the CORRECT source
      // The receipt link is at the TOP LEVEL of the appointment object
      let receiptLink = item.receipt_download_link || null;
      
      // If not found at top level, check queue as fallback
      if (!receiptLink && queue.receipt_download_link) {
        receiptLink = queue.receipt_download_link;
      }

      return {
        id: item.appointment_id,
        queue_id: queue_id,
        token_no: isNewPatient ? item.token_no || "0" : queue.token_no || "0",
        patient_marked: mark,
        is_payment: item?.is_payment || "No",
        is_emergency: queue.is_emergency || "No",
        is_pause: queue.is_pause || "No",
        questionnaire_filled: !isNewPatient && queue.questionnaire_filled 
          ? queue.questionnaire_filled 
          : item.questionnaire_filled || "No",
        systolic_bp: !isNewPatient ? queue.systolic_bp : null,
        diastolic_bp: !isNewPatient ? queue.diastolic_bp : null,
        bmi: !isNewPatient ? queue.bmi : null,
        pluse_rate: !isNewPatient ? queue.pluse_rate : null,
        temperature: !isNewPatient ? queue.temperature : null,
        Oxygen_Saturation: !isNewPatient ? queue.Oxygen_Saturation : null,
        blood_glucose_level: !isNewPatient ? queue.blood_glucose_level : null,
        Allergies: !isNewPatient ? queue.Allergies : null,
        Reports_Upload: !isNewPatient ? queue.Reports_Upload : null,
        height: !isNewPatient ? queue.height : null,
        weight: !isNewPatient ? queue.weight : null,
        gender: !isNewPatient && queue.gender ? queue.gender : item.gender || "N/A",
        occupation: !isNewPatient && queue.occupation ? queue.occupation : item.occupation || "",
        whatsapp_contact_no: !isNewPatient && queue.whatsapp_contact_no
          ? queue.whatsapp_contact_no
          : item.phone_no || "",
        date_of_birth: dob || null,
        doctor: !isNewPatient && queue.doctor_name ? queue.doctor_name : item.doctor_name || "N/A",
        marital_status: !isNewPatient && queue.is_married
          ? queue.is_married === "Yes" ? "Married" : "Not Married"
          : item.is_married === "Yes" ? "Married" : "Not Married",
          patient_photo: (() => {
            const photo =
              (!isNewPatient && queue?.patient_photo) ||
              item?.patient_photo ||
              item?.queueDetails?.patient_photo;
          
            if (!photo || photo === "null" || photo === "undefined" || photo.trim() === "") {
              return defaultAvatar;
            }
          
            return photo;
          })(),
        attend_status: item.appointment_visited === "Yes" ? "Attended" : "Not Attended",
        is_firsttime_visitor: item.is_firsttime_visitor || "No",
        is_presented: item.is_presented || "No",
        showReminder: item.appointment_visited !== "Yes",
        avatar: defaultAvatar,
        name: !isNewPatient
        ? `${item.first_name || ""} ${item.middile_name || ""} ${item.last_name || ""}`.trim()
        : item.patient_name || item.patient_full_name || "N/A",
        diseases: item.diseases || item.opd_diseases || "-",
        date: item.date || "-",
        timeSlot: item.time_slot || "-",
        mode: item.mode || "-",
        status: mark,
        partner_id: partner?.patient_id || null,
        partner_name: partner?.first_name
          ? `${partner.first_name} ${partner.last_name || ""}`.trim()
          : "",
        partner_phone: partner?.whatsapp_contact_no || partner?.additional_contact_no || "",
        patient_id: patient_id,
        doctor_id: item.doctor_id,
        phone: !isNewPatient && queue.whatsapp_contact_no ? queue.whatsapp_contact_no : item.phone_no || "-",
        email: queue.patient_email || item.email || "-",
        branch: item.branch_name || "-",
        city: item.city || queue.city || "-",
        showCollectButton:
  item?.is_payment?.trim() === "No" &&
  item?.is_presented?.trim() !== "No",
        showReceiptIcon: !isNewPatient ? queue.is_payment === "Yes" : item.is_payment === "Yes",
        
        // ✅ FIXED: Set the receipt download link from the top level
        receipt_download_link: receiptLink,
        partnerDetails: partner,
        queueDetails: queue,
        payment_id: patient_id,
        is_new_patient: isNewPatient,
        appointment_type: item.appointment_type,
        lead_id: item.lead_id || queue.lead_id,
        rescheduled_cnt: item.rescheduled_cnt || "0",
        telecaller_note: item.telecaller_note,
        cancellation_note: item.cancellation_note,
        age: dob ? new Date().getFullYear() - new Date(dob).getFullYear() : null
      };
    })
    .filter(item => item.patient_marked !== "Cancel")
    .sort((a, b) => {
      const order = { Current: 1, Next: 2, Waiting: 3 };
      return (order[a.status] || 99) - (order[b.status] || 99);
    });
}

// ==================== PARTNER QUESTIONNAIRE VALIDATION ====================

/**
 * Check if partner form is pending
 * @param {object} partnerDetails - Partner details object from API response
 * @returns {boolean} True if partner questionnaire is not filled
 */
export function isPartnerFormPending(partnerDetails) {
  return (
    partnerDetails &&
    String(partnerDetails.questionnaire_filled).trim() === "No"
  );
}

/**
 * Get partner form status with UI information
 * @param {object} partnerDetails - Partner details object from API response
 * @returns {object|null} Status object with label, color, icon, and actionRequired flag
 */
export function getPartnerFormStatus(partnerDetails) {
  if (!partnerDetails) return null

  if (partnerDetails.questionnaire_filled === "No") {
    return {
      label: "Partner Form Pending",
      color: "#ff6b6b",
      icon: "fas fa-exclamation-circle",
      actionRequired: true,
      priority: 0
    }
  }

  return {
    label: "Partner Form Completed",
    color: "#28a745",
    icon: "fas fa-check-circle",
    actionRequired: false,
    priority: 10
  }
}

/**
 * Check if patient actions should be disabled
 * @param {object} patient - Patient object with partnerDetails
 * @returns {boolean} True if partner form is pending (actions should be disabled)
 */
export function shouldDisableActionsForPartner(patient) {
  return isPartnerFormPending(patient?.partnerDetails)
}

/**
 * Get partner display information for UI
 * @param {object} partnerDetails - Partner details from API response
 * @returns {object} Object with partner info for UI display
 */
export function getPartnerDisplayInfo(partnerDetails) {
  if (!partnerDetails) return null

  return {
    patientId: partnerDetails.patient_id,
    firstName: partnerDetails.first_name,
    lastName: partnerDetails.last_name,
    fullName: `${partnerDetails.first_name} ${partnerDetails.last_name || ""}`.trim(),
    whatsappContact: partnerDetails.whatsapp_contact_no,
    additionalContact: partnerDetails.additional_contact_no,
    questionnaireFilled: partnerDetails.questionnaire_filled,
    isPending: partnerDetails.questionnaire_filled === "No",
    patientPhoto: partnerDetails.patient_photo || null
  }
}

/**
 * Validate patient data before queue actions
 * @param {object} patient - Patient object with partnerDetails
 * @returns {object} Validation result with isValid boolean and reason string
 */
export function validatePatientForQueueAction(patient) {
  // Check if partner form is pending
  if (isPartnerFormPending(patient?.partnerDetails)) {
    return {
      isValid: false,
      reason: "Partner questionnaire form must be completed before queue actions",
      blockingIssue: "partner_form_pending"
    }
  }

  return {
    isValid: true,
    reason: "Patient is ready for queue actions",
    blockingIssue: null
  }
}
